import I3TableItemType = ToroEnums.I3TableItemType;

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { I3AssetDown } from '../../../../../api/intelli360/models/i3-assets-down.model';
import { I3AssetWorkOrders } from '../../../../../api/intelli360/models/i3-open-work-orders.model';
import { I3MaintenanceDueAsset } from '../../../../../api/intelli360/models/i3-assets-maintenance-due.model';
import { I3OperatingStatusAsset } from '../../../../../api/intelli360/models/i3-assets-operating-status.model';
import { ToroEnums } from '../../../../../common/enumerations/toro.enums';

@Component({
    selector: 'toro-i3-table',
    templateUrl: './i3-table.component.html',
    styleUrls: ['./i3-table.component.less']
})
export class I3TableComponent {

    @Output() tableItemClick = new EventEmitter<I3AssetDown | I3AssetWorkOrders | I3MaintenanceDueAsset | I3OperatingStatusAsset>();

    @Output() selectedAssetChange = new EventEmitter<I3AssetDown | I3AssetWorkOrders | I3MaintenanceDueAsset | I3OperatingStatusAsset>();

    private _selectedAsset: I3AssetDown | I3AssetWorkOrders | I3MaintenanceDueAsset | I3OperatingStatusAsset;
    @Input() set selectedAsset(value: I3AssetDown | I3AssetWorkOrders | I3MaintenanceDueAsset | I3OperatingStatusAsset) {
        this._selectedAsset = value;
        this.selectedAssetChange.emit(value);
    }

    get selectedAsset() {
        return this._selectedAsset;
    }

    private _assets: I3AssetDown[] | I3AssetWorkOrders[] | I3MaintenanceDueAsset[] | I3OperatingStatusAsset[];
    @Input() set assets(value: I3AssetDown[] | I3AssetWorkOrders[] | I3MaintenanceDueAsset[] | I3OperatingStatusAsset[]) {
        if (value == null || value.length < 1) {
            this._assets = [];
            this._selectedAsset = null;
            return;
        }

        if (value[0] instanceof I3AssetDown) {
            this.itemType = I3TableItemType.AssetDown;
        } else if (value[0] instanceof I3AssetWorkOrders) {
            this.itemType = I3TableItemType.WorkOrder;
        } else if (value[0] instanceof I3MaintenanceDueAsset) {
            this.itemType = I3TableItemType.MaintenanceDueAsset;
        } else if (value[0] instanceof I3OperatingStatusAsset) {
            this.itemType = I3TableItemType.OperatingStatus;
        } else {
            throw new Error(`Unknown asset type ${typeof value}`);
        }

        this._assets = value;
    }

    get assets(): I3AssetDown[] | I3AssetWorkOrders[] | I3MaintenanceDueAsset[] | I3OperatingStatusAsset[] {
        return this._assets;
    }

    protected itemType: I3TableItemType;

    // =========================================================================================================================================================
    // Event Handlers
    // =========================================================================================================================================================

    onTableItemClick(tableItem: I3AssetDown | I3AssetWorkOrders | I3MaintenanceDueAsset | I3OperatingStatusAsset) {
        this.tableItemClick.next(tableItem);
    }
}
